export default __webpack_public_path__ + "static/Tatiane-4353e7f9fb53923d50dd832d0cb03829.png";